module.exports = __webpack_public_path__ + "static/media/convite_verso.b481f0a3.png";